export default __webpack_public_path__ + "static/media/image 166.381f8612.png";